import { formatPrice } from '@/lib/helpers';
import { TAgent, TAgentService, useAgentServices } from '@/models/agents';
import { Box, Button, Drawer, Table, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useState } from 'react';
import { PiPlusBold } from 'react-icons/pi';
import AddAgentService from '../agents/AddAgentService';
import AgentSelector from './AgentSelector';

export default function IncludeAgentServiceButton({
  included,
  onSelected,
}: {
  included: TAgentService[];
  onSelected: (e: TAgentService) => void;
}) {
  const [opened, { open, close }] = useDisclosure();
  const [agent, setAgent] = useState<TAgent>();

  const { data: agentServices } = useAgentServices(agent?.id ?? 0);

  return (
    <>
      <Drawer
        opened={opened}
        onClose={close}
        position="right"
        title="Include an agent service"
      >
        <AgentSelector onSelected={setAgent} />
        {agent && (
          <>
            <Text size="xs" fw={'500'} mt={'md'}>
              Agent services
            </Text>
            <Table highlightOnHover my={'sm'}>
              <Table.Tbody>
                {agentServices
                  ?.filter(
                    (e: TAgentService) => !included.find((i) => e.id == i.id),
                  )
                  .map((e: TAgentService) => (
                    <Table.Tr
                      key={e.id}
                      onClick={() => {
                        onSelected(e);
                        close();
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <Table.Td fz={'xs'}>{e.name}</Table.Td>
                      <Table.Td fz={'xs'} ta={'right'}>
                        {formatPrice(e.cogs, e.currency)}
                      </Table.Td>
                    </Table.Tr>
                  ))}
              </Table.Tbody>
            </Table>

            <Box ta={'right'} my={'md'}>
              <AddAgentService agent={agent} />
            </Box>
          </>
        )}
      </Drawer>
      <Button
        size="xs"
        variant="light"
        onClick={open}
        leftSection={<PiPlusBold />}
      >
        Include service
      </Button>
    </>
  );
}
